import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import AOS from "aos"
import { Parallax } from "react-scroll-parallax"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Seo from "../components/seo"
import Layout from "../components/layout"
import Section from "../components/section"
import Hero from "../components/section-elements/hero"
import SexyBtn from "../components/section-elements/sexy-button"
import "aos/dist/aos.css"
import ParticleBanner from "../components/section-elements/particle-banner"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

const HomePage = () => {

  useEffect(() => {
    AOS.init({
      easing: 'ease-in-out-quart', // default easing for AOS animations 
    })
  })

  const { executeRecaptcha } = useGoogleReCaptcha()

  var inquiryNames = ["General Inquiries"]

  const [activeInquiry, setActiveInquiry] = useState("General Inquiries")

  const changeInquiry = (name) => {
    setActiveInquiry("")

    setTimeout(() => {
      setActiveInquiry(name)
    }, 100)
  }

  const [fullName, setFullName] = useState("")
  const [organisation, setOrganisation] = useState("")
  const [emailAddress, setEmailAddress] = useState("")
  const [phone, setPhone] = useState("")
  const type = activeInquiry
  const [inquiry, setInquiry] = useState("")
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [formError, setFormError] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    // check if the captcha was skipped or not
    if (!executeRecaptcha) { return }

    const token = await executeRecaptcha("contact")
    const api = "https://cl3iq3kbbk.execute-api.us-east-1.amazonaws.com/default/abed-website-mailer-sendgrid"
    const data = { "name": fullName, "organisation": organisation, "email": emailAddress, "phone": phone, "type": type, "inquiry": inquiry, "token": token }

    fetch(api, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data)
    })
      .then(response => response.text())
      .then(data => {
        setFullName("")
        setOrganisation("")
        setEmailAddress("")
        setPhone("")
        setInquiry("")

        if (data === "Email Sent!") {
          setFormSubmitted(true);
          setFormError(false);
        } else {
          setFormSubmitted(false);
          setFormError(true);
        }
      })
  }


  return (
    <Layout>
      <Section maxWidthClass="max-w-theme-max-w"
        background={
          <>
            <div id="top" className="absolute w-full h-full h-min-['768px']" style={{ background: 'linear-gradient(transparent,#000000)' }}></div>
            <ParticleBanner />
          </>

        }
        className={`overflow-hidden content-hero pb-0 pt-0 sm:py-0`}
      >
        <Parallax speed={-30} className="top-20">
          <Hero className="text-center" >
            {/* <h1 className="text-theme-yellow tracking-[.4em] font-medium text-center text-xl mt-16 sm:text-xs pb-4 pt:0">
              Private Family Office
            </h1> */}
            <div className="flex-auto text-center self-center">
              <StaticImage
                src="../images/abed-group-logo.svg"
                loading="eager"
                width={320}
                formats={["auto", "webp", "avif"]}
                alt={'logo'}
                className="inline-block"
              />
            </div>
            <h3 className="font-xl text-center text-theme-yellow text-2xl sm:text-xl/8 leading-normal sm:leading-normal mt-4 sm:mt-8">
              Redefining the Family Office with Innovation at the Core
            </h3>
            <h4 className="font-small font-light text-center text-base sm:text-xl/8 leading-normal sm:leading-normal mt-4 sm:mt-4">
              Innovation guides our holistic approach, transforming the way we redefine wealth management.
            </h4>


          </Hero>
        </Parallax>
      </Section>

      <Section id="whatwedo" className="py-10 sm:py-section mx-auto section-bg text-center">
        {/* <h3 data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate text-theme-yellow pb-8">Services</h3> */}

        <h2 id="whatwedo" data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate section-header font-abed">Innovation Meets Vision</h2>

        <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate section-content mt-4">
          Founded in 2020, the <span className="font-bold text-theme-yellow">Abed Group</span> stands as a trailblazing force in the financial realm, redefining the very essence of family office dynamics. We are not just curators of portfolios; we are architects of a holistic vision. Through Abed Assets, Abed Equities, and Abed Realty, our innovation-driven approach transcends conventional boundaries, shaping a future where financial prosperity meets a profound commitment to excellence.
        </div>

        <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate hidden">
          <SexyBtn to="/about-us" text="Learn More" className="theme-btn bg-black hover:bg-black inline-block mt-8" />
        </div>

        <div className="flex gap-x-8 mt-10 sm:mt-14 text-left flex-col sm:flex-row">
          <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full relative">
            <div className='relative'>
              <div className="absolute  bg-opacity-50 w-full h-full z-10" style={{ background: 'radial-gradient(transparent,#000000dd)' }} />
              <StaticImage
                loading="lazy"
                alt={'equity'}
                objectFit={"contain"}
                objectPosition={"left"}
                className={'grayscale'}
                src={'../images/assets.jpg'}
              />
            </div>

            <div className="mt-10 text-2xl font-abed text-theme-yellow">Abed Assets</div>
            <div className="my-4 font-light text-md">From domain lease and sale to tokens designed for both liquidity and strategic sales, our asset management approach adapts to the evolving dynamics of the digital age.</div>

          </div>

          <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full">
            <div className='relative'>
              <div className="absolute  bg-opacity-50 w-full h-full z-10" style={{ background: 'radial-gradient(transparent,#000000dd)' }} />
              <StaticImage
                loading="lazy"
                alt={'equity'}
                objectFit={"contain"}
                objectPosition={"left"}
                className={'grayscale'}
                src={'../images/equity.jpg'}
              />
            </div>
            <div className="mt-10 text-2xl font-abed text-theme-yellow">
              Abed Equities
            </div>
            <div className="my-4 font-light text-md">Our focus extends to the careful management of securities and dividends, emphasizing the long-term prosperity these investments can bring.
            </div>

          </div>

          <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full">
            <div className='relative'>
              <div className="absolute  bg-opacity-50 w-full h-full z-10" style={{ background: 'radial-gradient(transparent,#000000dd)' }} />
              <StaticImage
                loading="lazy"
                alt={'equity'}
                objectFit={"contain"}
                objectPosition={"left"}
                className={'grayscale'}
                src={'../images/realty.jpg'}
              />
            </div>
            <div className="mt-10 text-2xl font-abed text-theme-yellow">Abed Realty</div>
            <div className="my-4 font-light text-md">From commercial and residential properties to the consistent returns of rental income and sales proceeds, our realty portfolio reflects a commitment to sound and tangible investments.
            </div>
          </div>
        </div>
      </Section>



      <Section id="contact" className={"py-10 sm:py-section section-bg"}>
        <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate services-filter font-large gap-x-10 flex">
          {inquiryNames.map((name, i) => {
            return (
              <button
                key={i}
                className={`pb-3 font-abed capitalize text-base sm:text-4xl leading-normal border-[#fac013] font-bold ${activeInquiry === name ? 'border-b-2' : 'mb-0.5'}`}
                onClick={() => changeInquiry(name)}
              >
                {name}
              </button>
            )
          })}
        </div>

        <div className="flex flex-wrap gap-10 sm:gap-14 mt-4 sm:mt-14">
          <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full lg:flex-1 font-light text-base sm:text-2xl leading-normal sm:leading-normal text-center sm:text-left">
            {/* <div className={`${activeInquiry === inquiryNames[0] ? '' : 'hidden'}`}>
              Want to reach out? Enter your information here and our team will get back to you with more information.
            </div> */}

            <div className={` text-base ${activeInquiry === inquiryNames[0] ? '' : 'hidden'}`}>
              Get in touch with us today! Please fill out this form and our team will do our best to respond as soon as possible.
            </div>

            <div className="flex flex-col mt-12 sm:flex-row justify-between">
              <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full  section-bg">

                <div className="pb-6">
                  <div className="text-base leading-normal font-light">Phone</div>

                  <div className="text-base leading-normal font-semibold">
                    <OutboundLink href="tel:+12462656209" target="_blank" rel="noreferrer" className="">
                      +1 (246) 265-6209
                    </OutboundLink>
                  </div>
                </div>

                <div className="pb-6">
                  <div className="text-base leading-normal font-light border-t border-[#fac013] pt-4">Email Address</div>

                  <div className="text-base leading-normal font-semibold">
                    <OutboundLink href="mailto:info@abed.com" target="_blank" rel="noreferrer" className="">
                      info@abed.com
                    </OutboundLink>
                  </div>
                </div>

                <div>
                  <div className="text-base leading-normal font-light border-t border-[#fac013] pt-4">Business Address</div>

                  <div className="text-base leading-normal font-semibold">
                    #8 Hastings Plaza, Hastings, Christ Church, Barbados
                  </div>
                </div>
              </div>



            </div>
          </div>

          <div data-aos="fade-up" data-aos-delay="0" className="aos-init aos-animate w-full lg:flex-1">
            <form method="post" action="#" onSubmit={handleSubmit} className={`${formSubmitted ? "hidden" : "flex flex-1 flex-col"} ${formError ? "hidden" : ""}`}>
              <label>
                <span className="text-base leading-normal font-light ">Full Name:</span>
                <input
                  type="text"
                  name="name"

                  // placeholder="Full Name"
                  className="theme-input bg-[#161616] border-b border-solid border-b-[#fac013] rounded-[5px_5px_0_0] outline-none"
                  required
                  onChange={event => setFullName(event.target.value)}
                  value={fullName}
                />
              </label>

              <label className="mt-4">
                <span className="text-base leading-normal font-light">Organization:</span>
                <input
                  type="text"
                  name="organisation"
                  // placeholder="Organization"
                  className="theme-input bg-[#161616] border-b border-solid border-b-[#fac013] rounded-[5px_5px_0_0] outline-none"
                  onChange={event => setOrganisation(event.target.value)}
                  value={organisation}
                />
              </label>
              <label className="mt-4">
                <span className="text-base leading-normal font-light">Email:</span>
                <input
                  type="email"
                  name="email"
                  // placeholder="Email Address"
                  className="theme-input bg-[#161616] border-b border-solid border-b-[#fac013] rounded-[5px_5px_0_0] outline-none"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                  onChange={event => setEmailAddress(event.target.value)}
                  value={emailAddress}
                />
              </label>
              <label className="mt-4">
                <span className="text-base leading-normal font-light">Phone:</span>
                <input
                  type="tel"
                  name="phone"
                  // placeholder="Phone"
                  className="theme-input bg-[#161616] border-b border-solid border-b-[#fac013] rounded-[5px_5px_0_0] outline-none"
                  required
                  onChange={event => setPhone(event.target.value)}
                  value={phone}
                />
              </label>
              <label className="mt-4">
                <span className="text-base leading-normal font-light ">Inquiry Details:</span>
                <textarea
                  name="inquiry"
                  // placeholder="Inquiry Details"
                  className="theme-textarea bg-[#161616] border-b border-solid border-b-[#fac013] rounded-[5px_5px_0_0] outline-none"
                  onChange={event => setInquiry(event.target.value)}
                  value={inquiry}
                  row="4"
                />

              </label>
              {/* <div className="font-light text-xs sm:text-xl leading-normal sm:leading-normal my-4">
                This site is protected by reCAPTCHA and the
                Google <OutboundLink href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="font-light text-xs sm:text-xl leading-normal sm:leading-normal underline">Privacy Policy</OutboundLink> and <OutboundLink href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="font-light text-xs sm:text-xl leading-normal sm:leading-normal underline">Terms of Service</OutboundLink> apply.
              </div> */}

              <input type="submit" className="my-4 btn-white-tr theme-btn bg-[#fac013] hover:bg-white-smoke text-black font-bold inline-block hover:shadow-theme-white-button cursor:pointer transition-shadow duration-250 ease-linear cursor-pointer" value={`${activeInquiry === inquiryNames[0] ? 'Submit' : 'Get In Touch'}`} />
            </form>

            <div className={`${formSubmitted ? 'animate-fade-in-bottom-25' : 'hidden'}`}>
              <h1 className="section-header-form text-center sm:text-left text-black">
                Thank you for your interest. We will respond as soon as possible.
              </h1>
            </div>

            <div className={`${formError ? 'animate-fade-in-bottom-25' : 'hidden'}`}>
              <h1 className="section-header-form text-center sm:text-left text-black">
                There was a problem with your request. Please try again later.
              </h1>
            </div>
          </div>
        </div>
      </Section>
    </Layout >
  )
}

export const Head = () => <Seo title="Home" />

export default HomePage

export const pageQuery = graphql`
  query {
    logos: allFile(filter: {relativeDirectory: {eq: "company-logos"}}) {
      edges {
        node {
          name
          publicURL
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }
    }
  }
`